export function nugetIdToUrlAlias(packageId: string): string {
  return packageId.toLowerCase();
}

export function urlPathToNugetId(path: string): string | undefined {
  return window.decodeURI(path)?.split('/package/').pop();
}
